// extracted by mini-css-extract-plugin
export default {"menu":"Menu-module--menu--3Fty1","open":"Menu-module--open--387ku"};